<template>
  <div>
    <vx-card>
      <div id="data-list-list-view" class="data-list-container">
        <vs-table
          noDataText="Nenhum Recebedor encontrado"
          class="tablePrincipal"
          ref="table"
          multiple
          v-model="selected"
          pagination
          :max-items="itemsPerPage"
          search
          :data="itens"
        >
          <div
            slot="header"
            class="flex flex-wrap-reverse items-center flex-grow justify-between"
          >
            <div class="flex flex-wrap-reverse items-center">
              <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
                <div
                  class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32"
                >
                  <span class="mr-2">Ações</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>

                <vs-dropdown-menu>
                  <vs-dropdown-item @click="ativar(false)">
                    <span>Inativar</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="ativar(true)">
                    <span>Reativar</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item>
                    <span>
                      <downloadexcel
                        :data="selected"
                        :fields="colunas"
                        name="Carteiras.xls"
                        type="xls"
                        >Exportar</downloadexcel
                      >
                    </span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>

              <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
                <div
                  class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium"
                >
                  <span class="mr-2">Filtrar por:</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>

                <vs-dropdown-menu>
                  <vs-dropdown-item @click="buscaDados('ativo')">
                    <span>Ativos</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="buscaDados('inativo')">
                    <span>Inativos</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="buscaDados('todos')">
                    <span>Todos</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>

              <div
                v-if="decoded.idEmpresa"
                class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
                @click="openModalInsertEdit(null)"
              >
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                <span class="ml-2 text-base text-primary"
                  >Adicionar novo recebedor</span
                >
              </div>
            </div>

            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
              <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2">
                  {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                  {{
                    itens.length - currentPage * itemsPerPage > 0
                      ? currentPage * itemsPerPage
                      : itens.length
                  }}
                  de {{ itens.length }}
                </span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>

              <vs-dropdown-menu>
                <vs-dropdown-item @click="itemsPerPage = 5">
                  <span>5</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 50">
                  <span>50</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>

          <template slot="thead">
            <vs-th sort-key="idRecebedor">Id</vs-th>
            <vs-th sort-key="nomeRecebedor">Nome</vs-th>
            <vs-th sort-key="porcentagem">Porcentagem</vs-th>
            <vs-th sort-key="deletedAt">Pagar.me</vs-th>
            <vs-th sort-key="deletedAt">Id Externo</vs-th>
            <vs-th sort-key="deletedAt">Status</vs-th>
            <vs-th>Ações</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <p>{{ tr.idRecebedor }}</p>
                </vs-td>
                <vs-td>
                  <p>
                    {{ tr.nomeRecebedor }}
                    <span v-if="tr.principal"> (principal)</span>
                  </p>
                </vs-td>
                <vs-td>
                  <p v-if="tr.porcentagem">{{ tr.porcentagem }} %</p>
                </vs-td>
                <vs-td>
                  <vs-chip
                    color="success"
                    v-if="tr.idExterno && tr.dadosPagarme"
                  >
                    Integrado
                  </vs-chip>
                </vs-td>
                <vs-td>{{ tr.idExterno }}</vs-td>
                <vs-td>
                  <vs-chip :color="getStatusColor(tr.deletedAt)">
                    {{ getStatusString(tr.deletedAt) }}
                  </vs-chip>
                </vs-td>
                <vs-td>
                  <p class="flex">
                    <vs-button
                      v-if="
                        (tr.idCarteira == 1 &&
                          decoded.idDistribuidor == null) ||
                        tr.idCarteira != 1
                      "
                      v-tooltip="'Editar'"
                      radius
                      color="success"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="d-inline"
                      @click="openModalInsertEdit(tr)"
                    ></vs-button>
                  </p>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vx-card>

    <vs-popup title="Recebedores" :active.sync="showModal" @close="closeModais">
      <FormRecebedores
        :dataRecebedor="dataModal"
        @savedRecebedor="savedRecebedor"
      />
    </vs-popup>
  </div>
</template>

<script>
import FormRecebedores from "./FormRecebedores.vue";
import downloadexcel from "vue-json-excel";
import service from "../../../../services";
import utilsList from "./../../../../utils/list";

export default {
  components: {
    FormRecebedores,
    downloadexcel,
  },
  data() {
    return {
      decoded: utilsList.buscaToken(),
      selected: [],
      itemsPerPage: 10,
      itens: [],
      colunas: {
        ["Nome Recebedor"]: "nomeRecebedor",
        Porcentagem: "porcentagem",
      },
      isMounted: false,
      showModal: false,
      dataModal: null,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  methods: {
    async buscaDados(filtrarpor = "todos") {
      this.selected = [];
      this.$vs.loading();

      try {
        const res = await service.getAll(
          "CarteiraCobranca",
          {},
          `Recebedores/Listar/${filtrarpor}?idEmpresa=null`
        );

        this.itens = res.data;
      } catch (error) {
        this.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: "Nenhum Registro Encontrado",
          color: "danger",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    getStatusColor(data) {
      if (data == null) return "success";
      return "danger";
    },
    getStatusString(data) {
      if (data == null) return "Ativo";
      return "Inativo";
    },
    openModalInsertEdit(value) {
      if (!value) {
        value = {
          idEmpresa: 1,
          idCarteira: 6,
        };
      }

      this.dataModal = value;
      this.showModal = true;
    },
    closeModais() {
      this.dataModal = null;
      this.showModal = false;
    },
    async savedRecebedor() {
      this.closeModais();
      await this.buscaDados();
    },
    async ativar(value) {
      if (!this.selected.length) {
        return;
      }

      try {
        const data = this.selected.map((element) => element.idRecebedor);
        const action = value ? "Ativar" : "Inativar";

        await service.post("CarteiraCobranca/Recebedores", action, data);

        await this.buscaDados();
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: error,
          color: "danger",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  created() {
    this.buscaDados();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style>
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
